import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import PageLoader from '../components/global/PageLoader';
import * as authFns from '../functions/auth';

import '../static/pilotly.css';

import {
	setCurrentUser,
	setActivityList,
	setMyList,
	setPilotlyPoints,
	setUserMonitor,

	setTargetParams,
	setFetchedDistributionList,
	setFetchedGroup,
	setFetchedGroupPanelSegment,
	setFetchedEpisode
} from '../redux/actions/index';

class Logout extends Component {
	constructor(props) {
		super(props);
		this.state = {};
        
		this.clearReduxProps = this.clearReduxProps.bind(this);
	}

	componentDidMount() {
		authFns.logout(() => {
			this.clearReduxProps();
			this.props.history.push('/');
		});
	}
    
	clearReduxProps() {
		this.props.setCurrentUser(null);
		this.props.setActivityList(null);
		this.props.setMyList(null);
		this.props.setPilotlyPoints(null);
		this.props.setUserMonitor(null);

		this.props.setTargetParams(null);
		this.props.setFetchedDistributionList(null);
		this.props.setFetchedGroup(null);
		this.props.setFetchedGroupPanelSegment(null);
		this.props.setFetchedEpisode(null);
	}


	render() {
		return (
			<div className="pilotly-logout">
				<PageLoader addedClass="pilotly-blue-background" loading={true} small={true} />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		userMonitor: state.currentUser.userMonitor,
		pilotlyPoints: state.currentUser.userPilotlyPoints,
		activityList: state.homeLists.activityList,
		activityListTimestamp: state.homeLists.activityListTimestamp,

		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedGroup: state.targetProcess.fetchedGroup,
		targetParams: state.targetProcess.targetParams
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setCurrentUser,
		setActivityList,
		setMyList,
		setPilotlyPoints,
		setUserMonitor,

		setTargetParams,
		setFetchedDistributionList,
		setFetchedGroup,
		setFetchedGroupPanelSegment,
		setFetchedEpisode
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Logout);


// WEBPACK FOOTER //
// ./src/pages/Logout.js